

import './arasamtavrobo.css';
import { useState } from 'react';
import { NGOCard } from './NGOCard';
import { ngos } from './ngos';
import { SeeAllButton } from '../../../components/seeallbutton/SeeAll';

export function AraSamtavrobo() {
  const [expanded, setExpanded] = useState(false);
  const handleExpand = () => setExpanded(prev => !prev);

  return (

    <div className="zipotela">
      <div className={`arasamtavrobo ${expanded ? 'expanded' : ''}`}>
      <div className="arasamtavrobo-title">
        <h1>Non-Governmental Organizations</h1>
      </div>

      <div className={`arasamtavrobo-links ${expanded ? "expanded" : ""}`}>
        {ngos.map((ngo, index) => (
          <NGOCard key={index} {...ngo} />
        ))}
      </div>

      <SeeAllButton onClick={handleExpand} isExpanded={expanded} />
    </div></div>
    
  );
}

